import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ErrorService, LocalizationService } from '../../shared/services';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Locale } from '../../shared/models';

export const AuthGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const errorService: ErrorService = inject(ErrorService);
  const router: Router = inject(Router);
  const localizationService: LocalizationService = inject(LocalizationService);

  errorService.resetLastErrorMessage();

  const isUserLoggedIn: boolean = authService.getIsUserLoggedIn();

  if (!isUserLoggedIn) {
    const lang: Locale = localizationService.getCurrentLocale(isUserLoggedIn);
    void router.navigateByUrl(`/${lang}`);
  }

  return isUserLoggedIn;
};
